import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Authorization header from localStorage as fallback (when cookie blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setSessionToken = (token) => {
  if (token) localStorage.setItem('session_token', token);
  else localStorage.removeItem('session_token');
};
